export const setModalPasswordResetOpen = () => ({
  type: 'SET_MODAL_PASSWORD_RESET_OPEN',
});

export const setModalPasswordResetClosed = () => ({
  type: 'SET_MODAL_PASSWORD_RESET_CLOSED',
});

export const setModalLoginFormOpen = () => ({
  type: 'SET_MODAL_LOGIN_FORM_OPEN',
});

export const setModalForgotPasswordFormOpen = (email) => ({
  type: 'SET_MODAL_RESET_PASSWORD_FORM_OPEN',
  payload: email
});

export const setModalLoginFormClosed = () => ({
  type: 'SET_MODAL_LOGIN_FORM_CLOSED',
});

export const setModalProgramEditOpen = () => ({
  type: 'SET_MODAL_PROGRAM_EDIT_OPEN',
});

export const setModalProgramEditClosed = () => ({
  type: 'SET_MODAL_PROGRAM_EDIT_CLOSED',
});

export const setModalHelpOpen = () => ({
  type: 'SET_MODAL_HELP_OPEN',
});

export const setModalHelpClosed = () => ({
  type: 'SET_MODAL_HELP_CLOSED',
});

export const setModalConfirmOpen = () => ({
  type: 'SET_MODAL_CONFIRM_OPEN',
});

export const setModalConfirmClosed = () => ({
  type: 'SET_MODAL_CONFIRM_CLOSED',
});

export const setModalTermsOpen = () => ({
  type: 'SET_MODAL_TERMS_OPEN',
});

export const setModalTermsClosed = () => ({
  type: 'SET_MODAL_TERMS_CLOSED',
});
